export default __webpack_public_path__ + "maps-examples-data-driven-symbols-thumbnail-480-f3467ca8ca9652089b4c2303dee36eac.png";